<template lang="html">
  <v-card class="ma-0  d-flex flex-column" elevation="4" height="100%">
    <v-card-title class="text-h6 pb-2 mb-3">
      {{ title }} - {{ totalTitle }}: {{ total | toInt(0, unit) }}
    </v-card-title>
    <v-card-subtitle class="pb-0">
      {{ subtitle }}
    </v-card-subtitle>
    <v-card-text class="px-1 pb-0">
      <v-row>
      <v-col cols="12" md="5" lg="5">
        <v-simple-table dense>
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left">
                  Rank
                </th>
                <th class="text-left">
                  Address
                </th>
                <th class="text-right">
                  Amount
                </th>
                <th class="text-right">
                  % of Total
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(item, index) in list"
                :key="index"
                >
                <td>{{ index + 1 }}</td>
                <td>{{ item.name }}</td>
                <td class="text-right">{{ item.value | toInt(0, unit) }}</td>
                <td class="text-right">{{ item.value / total * 100 | toInt(2, "%") }}</td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-col>
      <v-col cols="12" md="7" lg="7">
        <highcharts class="mt-5" :options="chartOptions" />
      </v-col>
    </v-row>
    </v-card-text>
    <v-spacer></v-spacer>
    <v-card-actions  v-if="more" class="pt-0">
      <v-spacer></v-spacer>
      <v-btn
        plain
        x-small
        :to="more"
      >
        more
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import {
    Chart
  } from "highcharts-vue";
  import Highcharts from "highcharts";
  import HighchartsMore from "highcharts/highcharts-more";

  HighchartsMore(Highcharts);

  export default {
    name: "TopListsCard",
    props: [
      'title', 'totalTitle', 'subtitle', 'more', 'color', 'list', 'total', 'unit'
    ],
    components: {
      highcharts: Chart
    },
    data() {
      return {
        chartOptions: {
          chart: {
            backgroundColor: null,
            plotBackgroundColor: null,
            plotBorderWidth: null,
            plotShadow: false,
            type: 'bar',
            height: 370,
            style: {
              fontFamily: "Roboto, sans-serif"
            }
          },
          title: {
            text: ''
          },
          credits: {
            text: 'wiseinfo.io',
            href: "https://wiseinfo.io",
            style: {
              fontSize: "12px",
              color: "#aaaaaa"
            },
            position: {
              x: -20,
              y: -20
            }
          },
          yAxis: {
            title: ""
          },
          xAxis: {
            labels: {
              enabled: false,
            },
          },
          tooltip: {
            enabled: false,
          },
          legend: {
            enabled: false
          },
          plotOptions: {
            bar: {
              showInLegend: true,
              borderWidth: 0,
              // borderColor: "#323234",
              dataLabels: {
                align: 'right',
                x: -0,
                // alignTo: 'plotEdges',
                style: {
                  fontSize: "11px",
                },
                format: "{point.y:,.0f} " + this.unit,
                inside: true,
                enabled: true,
              }
            }
          },
          series: [{
            color: this.color,
            data: this.list.map(holder => holder.value),
          }],
        }
      }
    },
    watch: {
      list() {
        this.generateData();
      },
    },
    methods: {
      generateData() {
        this.chartOptions.series[0].data = this.list.map(holder => holder.value);
      }
    }
  }
</script>

<style lang="css">
  .factor {
    font-size: 1.50em !important;
    font-weight: bold;
    color: green;
    text-shadow: 0px 0px 5px green;

  }
</style>
